// import { getDictionariesCom } from '@/utils/index.js'

export default {
  props: {},
  data () {
    return {
      userInfo: {}
    }
  },
  computed: {},
  filters: {},
  created () {

  },
  methods: {
    // 获取平台列表
    getPlatformList () {
      const params = {}
      this.$api.platformDataList(params).then((res) => {
		  console.log(res)
        this.platformList = res.data
        const tempArr = []
        /*
        健驰健康服务小程序
        天兰茶叶（优购）小程序
        九航云选小程序
        九航大健康
        宜关小程序
        天兰小程序
        九航云选app
         */
        res.data.forEach(item => {
          if (item.name.indexOf('app') > -1 || item.name.indexOf('小程序') > -1  || item.name.indexOf('大健康') > -1 || item.name.indexOf('九航') > -1 ) {
            tempArr.push(item)
          }
        })
        this.platformListFilter = tempArr
      }).catch((err) => {
        console.log(err)
      })
    },
  }
}
